import _ from 'lodash';
import I18nMgmt from 'iceqerp-common/i18n-mgmt';
import apiProxy from '@/apis/api-proxy-inst';

class MyI18nMgmt extends I18nMgmt {
  init() {
    return super.init().then(data => {
      apiProxy.setLang(this.getCurLang());
      return data;
    });
  }

  setLang(i18n, lang) {
    return super.setLang(i18n, lang).then(data => {
      apiProxy.setLang(this.getCurLang());
      return data;
    });
  }
}

const i18nMgmt = new MyI18nMgmt({
  langList: [
    { value: 'en', label: 'English' },
    { value: 'zh-CN', label: '简体中文' },
    { value: 'th', label: 'ไทย' },
    { value: 'id', label: 'Bahasa Indonesia' },
    { value: 'my', label: 'Bahasa Melayu' },
    { value: 'de', label: 'Deutsch' },
    { value: 'es', label: 'Español' },
    { value: 'pt', label: 'Português' }
  ],
  langPackageLoader: {
    load(lang) {
      let promise = null;
      if (lang === 'zh-CN') {
        promise = Promise.all([
          import(/* webpackChunkName: "lang-el-[request]" */ './lang/element-ui/zh-CN'),
          import(/* webpackChunkName: "lang-app-[request]" */ './lang/zh-CN')
        ]);
      } else if (lang === 'de') {
        promise = Promise.all([
          import(/* webpackChunkName: "lang-el-[request]" */ './lang/element-ui/de'),
          import(/* webpackChunkName: "lang-app-[request]" */ './lang/de')
        ]);
      } else if (lang === 'es') {
        promise = Promise.all([
          import(/* webpackChunkName: "lang-el-[request]" */ './lang/element-ui/es'),
          import(/* webpackChunkName: "lang-app-[request]" */ './lang/es')
        ]);
      } else if (lang === 'id') {
        promise = Promise.all([
          import(/* webpackChunkName: "lang-el-[request]" */ './lang/element-ui/id'),
          import(/* webpackChunkName: "lang-app-[request]" */ './lang/id')
        ]);
      } else if (lang === 'my') {
        promise = Promise.all([
          import(/* webpackChunkName: "lang-el-[request]" */ './lang/element-ui/my'),
          import(/* webpackChunkName: "lang-app-[request]" */ './lang/my')
        ]);
      } else if (lang === 'pt') {
        promise = Promise.all([
          import(/* webpackChunkName: "lang-el-[request]" */ './lang/element-ui/pt'),
          import(/* webpackChunkName: "lang-app-[request]" */ './lang/pt')
        ]);
      } else if (lang === 'th') {
        promise = Promise.all([
          import(/* webpackChunkName: "lang-el-[request]" */ './lang/element-ui/th'),
          import(/* webpackChunkName: "lang-app-[request]" */ './lang/th')
        ]);
      } else {
        promise = Promise.all([
          import(/* webpackChunkName: "lang-el-[request]" */ './lang/element-ui/en'),
          import(/* webpackChunkName: "lang-app-[request]" */ './lang/en')
        ]);
      }
      return promise.then(packages => {
        _.assign(packages[0].default, packages[1].default);
        return packages[0].default;
      });
    }
  }
});

export default i18nMgmt;
